import { useState, useRef, useEffect } from "preact/hooks";
import { h } from "preact";
import { ServiceInfo, defaultCharacteristics } from "./GATT";

export function CharacterisitcManager(props: { showDefault?: boolean, onChange: (services: ServiceInfo[]) => void }) {
    const [customServices, setCustomServices] = useState<ServiceInfo[]>(JSON.parse(localStorage.getItem("customCharacteristics") ?? "[]"));
    const customServiceNameRef = useRef<HTMLInputElement>();
    const customServiceUUIDRef = useRef<HTMLInputElement>();
    const customServiceSelectRef = useRef<HTMLSelectElement>();

    useEffect(() => {
        props.onChange(customServices);
    }, [customServices]);

    return <div>
        <div style={{ display: "flex" }}>
            <select ref={customServiceSelectRef} size={10} style={{ minWidth: "300px" }}>
                {customServices.map((s, i) => <option value={i}>
                    {s.name} - {s.uuid}
                </option>)}
            </select>
            {props.showDefault ? <select size={20}>
                {defaultCharacteristics.map(s => <option value={s.uuid}>
                    {s.name} - {s.uuid} - {s.spec}
                </option>)}
            </select> : null}
        </div>
        <div>
            <div style={{ marginTop: "5px" }}>Add custom characteristic</div>
            <div style={{ marginTop: "5px" }}>
                <span style={{ display: "inline-block", width: "50px" }}>Name:</span> <input ref={customServiceNameRef}/>
            </div>
            <div style={{ marginTop: "5px" }}>
                <span style={{ display: "inline-block", width: "50px" }}>UUID:</span> <input ref={customServiceUUIDRef}/>
            </div>
            <button style={{ marginTop: "5px", marginRight: "10px" }} onClick={() => {
                customServices.push({
                    name: customServiceNameRef.current!.value, uuid: customServiceUUIDRef.current!.value
                });

                setCustomServices(customServices.slice());
                localStorage.setItem("customCharacteristics", JSON.stringify(customServices));
                props.onChange(customServices);
            }}>Add</button>
            <button style={{ background: "#e74c3c"}} onClick={() => {
                customServices.splice(parseInt(customServiceSelectRef.current!.value, 10), 1);
                setCustomServices(customServices.slice());
                localStorage.setItem("customCharacteristics", JSON.stringify(customServices));
                props.onChange(customServices);
            }}>Remove selected</button>
        </div>
    </div>;
}
